import { Component} from '@angular/core';

@Component({
    selector: 'payment-main',
    templateUrl: './payment-main.tmpl.html'
})

export class PaymentMain {
    editMode: boolean = null; 

    public setVal(val:boolean) {
        this.editMode = val;  
    }
}
  